/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// It is not considering import as declaration , throwing lint error at import statement itself

import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { WidgetsModule } from '@support/shared/widgets/widgets.module';

import { TemplateComponent } from '@core/aem/components/template/template.component';
import { DynamicComponent } from '@core/aem/components/dynamic/dynamic.component';
import { DynamicHostDirective } from '@core/aem/directives/dynamic-host.directive';
import { SharedBrowseModule } from '@experience/shop/shared-browse/shared-browse.module';
import { AccessorySectionModule } from '@experience/shop/accessory-section/accessory-section.module';

// Dynamically Generated Components
import { SafeStylePipe } from '@core/aem/pipes/safe-style.pipe';
import { DynamicRouteComponent } from '@core/aem/components/dynamic-route/dynamic-route.component';
import { ContainerHolderComponent } from '@core/aem/components/container-holder/container-holder.component';
import { ContainerComponent } from '@core/aem/components/container/container.component';
import { HeaderTextComponent } from '@core/aem/components/header-text/header-text.component';
import { AdaptiveImageComponent } from '@core/aem/components/adaptive-image/adaptive-image.component';
import { HorizontalRuleComponent } from '@core/aem/components/horizontal-rule/horizontal-rule.component';
import { HtmlTemplateComponent } from '@core/aem/components/html-template/html-template.component';
import { SpacingSizeComponent } from '@core/aem/components/authorable-spacing-size/authorable-spacing-size.component';
import { ComparisonChartComponent } from '@core/aem/components/comparison-chart/comparison-chart.component';
import { LegalTextAuthorableComponent } from '@core/aem/components/legal-text-authorable/legal-text-authorable.component';
import { CtaButtonComponent } from '@core/aem/components/cta-buttons-authorable/cta-button.component';
import { CtaLinkComponent } from '@core/aem/components/cta-link/cta-link.component';
import { CoverageMapAuthorableComponent } from '@core/aem/components/coverage-map-authorable/coverage-map-authorable.component';
import { SafeUrlPipe } from '@core/aem/pipes/safe-url.pipe';
import { ImageGalleryComponent } from '@core/aem/components/image-gallery/image-gallery.component';
import { VideoGalleryComponent } from '@core/aem/components/video-gallery/video-gallery.component';
import { ProductFeaturesComponent } from '@core/aem/components/product-features/product-features.component';
import { ProductSpecificationComponent } from '@core/aem/components/product-specification/product-specification.component';
import { RelatedProductsComponent } from '@core/aem/components/related-products/related-products.component';
import { GalleryComponent } from '@core/aem/components/gallery/gallery.component';
import { ProductOfferingsComponent } from '@core/aem/components/product-offerings/product-offerings.component';
import { ProductOfferingsAccessoriesComponent } from '@core/aem/components/product-offerings-accessories/product-offerings-accessories.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@support/store/store.module';
import { ByodFaqAuthorableComponent } from '@core/aem/components/byod-faq-authorable/byod-faq-authorable.component';
import { BulletTextAuthorableComponent } from './components/bullet-text/bullet-text-authorable.component';
import { PageTitleTemplateComponent } from '@core/aem/components/page-title-template/page-title-template.component';
import { PurchaseDeviceModalComponent } from '@core/aem/components/purchase-device/purchase-device-modal.component';
import { RunDiagnosticTypeComponent } from '@core/aem/components/run-diagnostic/run-diagnostic.component';
import { PlanFamilyTitleComponent } from './components/plan-family-title/plan-family-title.component';
import { PlanProductOfferingComponent } from '@core/aem/components/plan-product-offering/plan-product-offering.component';
import { DeviceDetailsComponent } from '@core/aem/components/device-details/device-details.component';
import { ProductReviewsComponent } from '@core/aem/components/product-reviews/product-reviews.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UpgradeMultilineModalComponent } from '@experience/shop/shared-browse/components/upgrade-multiline-modal/upgrade-multiline-modal.component';
import { AccordionTextComponent } from '@core/aem/components/accordion-text/accordion-text.component';
import { ProductGalleryComponent } from '@core/aem/components/product-gallery/product-gallery.component';
import { ByodPageFaqComponent } from './components/byod-faq/byod-page-faq.component';
import { AccordionListComponent } from './components/accordion-list/accordion-list.component';
import { DeviceSelectionDetailsComponent } from './components/device-selection-details/device-selection-details.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    WidgetsModule,
    RouterModule,
    SharedBrowseModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule,
    InfiniteScrollModule,
    AccessorySectionModule,
  ],
  declarations: [
    TemplateComponent,
    DynamicComponent,
    DynamicHostDirective,
    SafeStylePipe,
    DynamicRouteComponent,
    ContainerHolderComponent,
    ContainerComponent,
    HeaderTextComponent,
    AdaptiveImageComponent,
    HorizontalRuleComponent,
    HtmlTemplateComponent,
    LegalTextAuthorableComponent,
    CtaButtonComponent,
    SpacingSizeComponent,
    CtaLinkComponent,
    CoverageMapAuthorableComponent,
    ImageGalleryComponent,
    VideoGalleryComponent,
    ProductFeaturesComponent,
    ProductSpecificationComponent,
    RelatedProductsComponent,
    GalleryComponent,
    ProductOfferingsComponent,
    SafeUrlPipe,
    ProductOfferingsAccessoriesComponent,
    ComparisonChartComponent,
    ByodFaqAuthorableComponent,
    BulletTextAuthorableComponent,
    PageTitleTemplateComponent,
    DeviceDetailsComponent,
    ProductReviewsComponent,
    PurchaseDeviceModalComponent,
    RunDiagnosticTypeComponent,
    PlanFamilyTitleComponent,
    PlanProductOfferingComponent,
    UpgradeMultilineModalComponent,
    AccordionTextComponent,
    ProductGalleryComponent,
    ByodPageFaqComponent,
    AccordionListComponent,
    DeviceSelectionDetailsComponent,
  ],
  exports: [
    ContainerHolderComponent,
    ProductOfferingsComponent,
    DeviceDetailsComponent,
    ProductReviewsComponent,
    ByodPageFaqComponent,
    AccordionListComponent,
    DeviceSelectionDetailsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AemModule { }
